import { IMetaContent } from '../types';
import { JWTPayload } from './tokenUtils';
import clevertap from 'clevertap-web-sdk';
import AppConfig from '../AppConfig';

export const initTracker = () => {
  // CleverTap initialization
  clevertap.privacy.push({ optOut: false }); // Set the flag to true, if the user of the device opts out of sharing their data
  clevertap.privacy.push({ useIP: false }); // Set the flag to true, if the user agrees to share their IP data
  clevertap.init(AppConfig.CLEVERTAP_ACCOUNT_ID, 'in1');
};

export const track = ({ event = '', data = {} }) => {
  clevertap?.event?.push(event, data);
};

export const getUser = (user?: JWTPayload) => {
  if (!user) {
    return null;
  }
  return {
    organisationId: user.organisationId,
    memberId: user.memberId,
    email: user.emailId,
  };
};

export const convertMetaToAnalyticsData = (meta: IMetaContent) => {
  return {
    articleId: meta.mixpanelArticleId,
    category: meta.mixpanelCategory,
    nodeId: meta.mixpanelNodeId,
    subCategory: meta.mixpanelSubcategory,
    path: meta.path,
  };
};
